import { ReactElement } from 'react';

import { Button } from '@equip.health/ui';

export type SecondaryCTAButtonProps = {
  display: string;
  isDisabled: boolean;
  leftIcon?: ReactElement;
  onClick: () => void;
};

const SecondaryCTAButton = ({
  display,
  isDisabled,
  leftIcon,
  onClick,
}: SecondaryCTAButtonProps) => (
  <Button
    activeColor="primary.50"
    id={`patient-profile-surveys-secondary-cta__${display}`}
    isDisabled={isDisabled}
    leftIcon={leftIcon}
    margin="0 8px 0 0"
    onClick={onClick}
    padding="12px"
    size="sm"
    variant="outline"
  >
    {display}
  </Button>
);

export default SecondaryCTAButton;
